import { DatasourceTableConnectionExtractIcon } from '@tableau/icons/DatasourceTableConnectionExtractIcon';
import { DatasourceTableConnectionIcon } from '@tableau/icons/DatasourceTableConnectionIcon';
import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { PublishedConnectionTableCard } from '~src/publishedConnectionTable/components/cardView/PublishedConnectionTableCard';
import { PublishedConnectionTables } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PublishedConnectionTableContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';
import { getPublishedConnectionTableInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const PublishedConnectionTableDefinition: MixedContentItemDefinition & SpaceDefinition<'virtualConnectionTable'>  = {
  contentType: 'virtualConnectionTable',
  itemType: 'virtualConnectionTable',
  pluralName: Messages.publishedConnectionTables,
  singularName: Messages.publishedConnectionTable,
  emptyStateMessage: Messages.publishedConnectionTablesEmpty,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PublishedConnectionTables,
  contentFilterKeys: PublishedConnectionTableContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: PublishedConnectionTableCard,
  listViewIconType: DatasourceTableConnectionIcon,
  filterClause: ServerFilterClauses.ContentType(['virtualConnectionTable']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.virtualConnectionTableUrl(contentId),
  getBasicQuery: () => {
    return PublishedConnectionTables.all().withExtraParams(PublishedConnectionTableContentType.extraQueryParams);
  },
  fieldValueResourceType: 'virtualConnectionTable',
  getContentInfo: (contentList: IContentInfo[]) => call(getPublishedConnectionTableInfos, contentList),
  supportedDisplayModes: ['list'],
  headerIconPath: (contentInfo) => getPublishedConnectionTableHeaderIconPath(contentInfo),
};

export const getPublishedConnectionTableHeaderIconPath = (contentInfo: ISpaceItemDetailInfo<'virtualConnectionTable'>): string => {
  const properties = [];
  if (contentInfo.hasExtracts) {
    properties.push('extract');
  }
  if (properties.length > 0) {
    properties.push('');
  }

  return imgPath(`table_connection_${properties.join('_')}60px_card.svg`);
};

export const getPublishedConnectionTableIcon = (contentInfo: ISpaceItemDetailInfo<'virtualConnectionTable'>, headerIcon: boolean = true):
                (props: any) => React.ReactSVGElement | null => {
  if (headerIcon) {
    return null;
  }

  if(contentInfo.hasExtracts) {
    return DatasourceTableConnectionExtractIcon;
  }
  else {
    return DatasourceTableConnectionIcon;
  }
};

